import React from 'react';
import { useHistory } from "react-router-dom";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import BreadCrumbs from '../../Common/BreadCrumbs';
import {
    PrimaryButton,
} from '../../Common';

const AccessDenied = ({
    breadCrumbText = 'Access Denied',
}) => {

    const history = useHistory();

    return (
        <>
            <BreadCrumbs
                path={[
                    { text: breadCrumbText, onClick: null }
                ]}
            />

            <div className="flex f-col f-center">

                <ErrorOutlineIcon color="error" sx={{ fontSize: 56 }} />

                <br />

                <p className="error404-text">You do not have permission to access this page.</p>

                <br />

                <p className="error404-text-small">If you believe you should have access to this page, please contact your System Administrator.</p>

                <br />

                <PrimaryButton
                    buttonText={"Go Back"}
                    onClick={() => (history.length > 1 ? history.goBack() : history.push('/'))}
                />
            </div>

        </>

    );
};

export default AccessDenied;
